import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import './ContactInsuranceForm.css';

const ContactInsuranceForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: ''
  });

  const [captchaValue, setCaptchaValue] = useState(null);
  const [status, setStatus] = useState({ success: null, message: '' });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, phone, message } = formData;

    if (!name || !phone || !message) {
      return setStatus({ success: false, message: 'נא למלא את כל השדות.' });
    }

    if (!captchaValue) {
      return setStatus({ success: false, message: 'אנא אמת שאתה לא רובוט.' });
    }

    try {
      const res = await fetch('/api/contact-insurance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, phone, message, captcha: captchaValue })
      });

      const data = await res.json();

      if (data.success) {
        setStatus({ success: true, message: 'הפרטים נשלחו בהצלחה!' });
        setFormData({ name: '', phone: '', message: '' });
        setCaptchaValue(null);
      } else {
        setStatus({ success: false, message: 'שגיאה בשליחת הטופס.' });
      }
    } catch (err) {
      console.error(err);
      setStatus({ success: false, message: 'שגיאה בשרת. נסה שוב מאוחר יותר.' });
    }
  };

  return (
    <form className="ContactInsuranceFormContainer" onSubmit={handleSubmit}>

      <input
        type="text"
        name="name"
        className="ContactInsuranceFormInputName"
        placeholder="שם מלא"
        value={formData.name}
        onChange={handleChange}
        required
      />

      <input
        type="tel"
        name="phone"
        className="ContactInsuranceFormInputPhone"
        placeholder="טלפון"
        value={formData.phone}
        onChange={handleChange}
        required
      />

      <textarea
        name="message"
        className="ContactInsuranceFormInputMessage"
        placeholder="הודעה"
        value={formData.message}
        onChange={handleChange}
        required
      />

      <div className="ContactInsuranceFormCaptchaBox">
        <ReCAPTCHA
          sitekey="6LcMcP0qAAAAAJKQPThonCPeHq2lmXlakfO0e-AE"
          onChange={handleCaptchaChange}
        />
      </div>

      <button
        type="submit"
        className="ContactInsuranceFormSubmitBtn"
        disabled={!captchaValue}
      >
        שלח 
      </button>

      {status.message && (
        <p
          className={`ContactInsuranceFormStatusMessage ${
            status.success ? 'ContactInsuranceFormSuccess' : 'ContactInsuranceFormError'
          }`}
        >
          {status.message}
        </p>
      )}
    </form>
  );
};

export default ContactInsuranceForm;
